import { Container, Row, Col } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import PageCover from "../Components/Shared/PageCover";
import planeRepair from "../Components/Assets/Images/plane-repairing-cut.png";
import ribbon from "../Components/Assets/Images/ribbons-blu.png";
import connection from "../Components/Assets/Images/eng-connection.png";
import planeEngine from "../Components/Assets/Images/engineImg.jpg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {faHandPointRight} from "@fortawesome/free-solid-svg-icons";

const Engineering = () => {
  return (
    <>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        viewport={{ once: false, amount: 0.5 }}
      >
        <PageCover
          image={require("../Components/Assets/Images/aircraftEngineering.jpg")}
          title="Engineering Excellence"
          subtitle="Innovating the Future of Technology"
        />
      </motion.div>
      <Box
        className="engSection"
        style={{ backgroundColor: "#d4dbdfd4", padding: "4rem 0" }}
      >
        <Container>
          <Col lg={12} md={6} sm={12} xs={12} className="handpickText ">
            <Typography variant="h6">Our Safety Excellence</Typography>
          </Col>
          <Row>
            <Col lg={6} md={6} sm={12} xs={12}>
              <motion.div
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <Box className="mb-4 handpickText">
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: "600 !important",
                      margin: "20px 0 !important",
                    }}
                  >
                    Maintaining world-class safety, performance, and innovation
                    in every ShankhAir flight.
                  </Typography>
                </Box>
                <Typography component="p" className="mb-4">
                  At ShankhAir, we are committed to delivering the highest
                  standards of safety and performance in aviation. Our
                  engineering team works tirelessly to ensure that every
                  aircraft meets rigorous safety protocols and operates at peak
                  efficiency. We leverage cutting-edge technology and innovative
                  solutions to enhance the flying experience for our passengers,
                  ensuring that each flight is not only safe but also
                  comfortable and reliable.
                </Typography>
                <Box component="ul" sx={{ pt: 3 }} className="higlight-ul">
                  <Typography component="li" variant="body1">
                    ✔️ Aircraft Engine Health Monitoring
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Mechanical Inspections & Repairs
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Aerodynamics & Fuel Efficiency
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Safety & Regulatory Compliance
                  </Typography>
                </Box>
              </motion.div>
            </Col>
            <Col lg={6}>
              <motion.div
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
                style={{ position: "relative" }}
              >
                <Box
                  component="img"
                  src={ribbon}
                  className="img-fluid ribbon"
                ></Box>
                <Box
                  component="img"
                  src={planeRepair}
                  className="img-fluid"
                  alt="Plane Repair"
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>
      <Box>
        <Container>
          <Row className="my-5">
            <Col lg={6}>
              <motion.div
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
                style={{ position: "relative" }}
              >
                {/* <Box
                  component="img"
                  src={ribbon}
                  className="img-fluid ribbon"
                ></Box> */}
                <Box
                  component="img"
                  src={connection}
                  className="img-fluid"
                  alt="Plane Repair"
                />
              </motion.div>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <motion.div
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <Box className="mb-4 handpickText">
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: "600 !important",
                      margin: "20px 0 !important",
                    }}
                  >
                    Maintaining world-class safety, performance, and innovation
                    in every ShankhAir flight.
                  </Typography>
                </Box>
                <Typography component="p" className="mb-4">
                  Beyond the aircraft, our engineering prowess extends to the
                  technology that keeps the airline running smoothly. Our
                  network and infrastructure teams ensure seamless communication
                  between ground operations, maintenance crews, and pilots.
                </Typography>
                <Typography component="p">
                  Our experienced Aerospace and Mechanical engineering teams
                  ensure that every aircraft meets the highest standards of
                  safety and efficiency. From engine overhauls and structural
                  integrity checks to routine maintenance, our engineers
                  leverage advanced diagnostics and strict procedures to keep
                  ShankhAir flights safe and on time.
                </Typography>
                <Box component="ul" sx={{ pt: 3 }} className="higlight-ul">
                  <Typography component="li" variant="body1">
                    ✔️ Reliable Ground Support Systems
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ IT Infrastructure for Real-Time Flight Data
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Predictive Maintenance Software
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Redundant Networks for 24/7 Uptime
                  </Typography>
                </Box>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>
      <Box
        className="engSection"
        style={{ backgroundColor: "#d4dbdfd4", padding: "4rem 0" }}
      >
        <Container>
          <Col lg={12} md={6} sm={12} xs={12} className="handpickText ">
            <Typography variant="h6">Checked | Certified | Ready to Fly</Typography>
          </Col>
          <Row>
            <Col lg={6} md={6} sm={12} xs={12}>
              <motion.div
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <Box className="mb-4 handpickText">
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: "600 !important",
                      margin: "20px 0 !important",
                    }}
                  >
                   Every Flight Starts with a Safety Check – Prioritizing Precision
                  </Typography>
                </Box>
                <Typography component="p" className="mb-4">
                  Before an aircraft ever leaves the ground, our skilled
                  engineering team performs a thorough safety check on every
                  critical component — from engines and control surfaces to
                  avionics and landing gear. This meticulous process ensures
                  that all systems are functioning flawlessly and meet strict
                  regulatory standards. By prioritizing these detailed
                  pre-flight inspections, we guarantee a safe, smooth, and
                  worry-free journey for every passenger on board.
                </Typography>
                <Box component="ul" sx={{ pt: 3 }} className="higlight-ul">
                  <Typography component="li" variant="body1">
                    ✔️ Comprehensive Pre-Flight Safety Inspections
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Thorough Aircraft Engine Health Monitoring
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Aerodynamics & Performance Optimization
                  </Typography>
                  <Typography component="li" variant="body1">
                    ✔️ Safety & Regulatory Compliance Checks
                  </Typography>
                </Box>
              </motion.div>
            </Col>
            <Col lg={6}>
              <motion.div
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: false, amount: 0.5 }}
                style={{ position: "relative" }}
              >
                <Box
                  component="img"
                  src={planeEngine}
                  className="img-fluid"
                  alt="Plane Repair"
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default Engineering;
